import { createContext, useContext } from "react"

export type AuthStrategy = "auth0" | "parent"

const AuthStrategyContext = createContext<AuthStrategy>("auth0")

export const useAuthStrategy = () => useContext(AuthStrategyContext)

export const AuthStrategyProvider = ({
  children,
  strategy,
}: {
  children: React.ReactNode
  strategy: AuthStrategy
}) => (
  <AuthStrategyContext.Provider value={strategy}>
    {children}
  </AuthStrategyContext.Provider>
)
